module.exports = __webpack_public_path__ + "static/Docker_mono-7279b006c01db8cee90b8822fa5aeb00.svg";